import { render, staticRenderFns } from "./DeadlineEntryRenewalDialog.vue?vue&type=template&id=9a5f55cc"
import script from "./DeadlineEntryRenewalDialog.vue?vue&type=script&lang=js"
export * from "./DeadlineEntryRenewalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports